enum UtilizationReportSorting {
  Team = 'Team',
  User = 'User',
  Date = 'Date',
  Module = 'Module',
}

export default UtilizationReportSorting;
